<template>
  <div>
      <PageHero
        :title="$t('hero.title_news')"
        :breadcrumbsTop="[
          { label: $t('hero.breadcrumbs.home'), link: '/' },
          { label: $t('hero.breadcrumbs.news') }
        ]"
      />
    <div class="container ptb-100">
      <div class="row">
        <div class="col-lg-8">
           <NewsPublicList />
        </div>
        <div class="col-lg-4">
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from 'axios'

import PageHero from '../components/PageHero.vue'
import NewsPublicList from '../pages/news_list/NewsPublicList.vue'
import NewsSearch from '../pages/news_list/NewsSearch.vue'
import NewsCategories from '../pages/news_list/NewsCategories.vue'
import NewsRecent from '../pages/news_list/NewsRecent.vue'
import NewsSubscribe from '../pages/news_list/NewsSubscribe.vue'
import NewsTags from '../pages/news_list/NewsTags.vue'

const news = ref([])
const categories = ref([])
const recentPosts = ref([])
const tags = ref([])

function onSearch(query) {
  console.log('search:', query)
}

function onPage(n) {
  console.log('go to page:', n)
}

onMounted(async () => {
  const response = await axios.get('/api/v2/news')
  news.value = response.data.news.map(n => ({
    id: n.id,
    title: n.title,
    excerpt: n.content?.slice(0, 100) + '...',
    date: new Date(n.published_at).toLocaleDateString('ru-RU'),
    category: n.category.name,
    image: n.image || '/img/blog/placeholder.jpg'
  }))

  categories.value = Array.from(
    news.value.reduce((map, n) => {
      map.set(n.category, (map.get(n.category) || 0) + 1)
      return map
    }, new Map())
  ).map(([name, count]) => ({ name, count }))

  recentPosts.value = news.value.slice(0, 3)
  tags.value = ['недвижимость', 'инвестиции', 'продажа', 'Анталья']
})
</script>

